import script from "./ProductPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPage.vue?vue&type=style&index=0&id=983ff238&lang=scss"

const __exports__ = script;

export default __exports__